/**
 * Polls the auth endpoint so the page reloads (re-applying anonymous map
 * rules) when the user's session expires.
 */
export class AuthSessionMonitor {

    public constructor(isAuthenticated: boolean) {
        if (isAuthenticated) {
            setInterval(function () {
                AuthSessionMonitor.checkAuthStatus();
            }, 120000); //every 2 minutes check if user is still authenticated
        }
    }

    private static checkAuthStatus(): void {
        $.ajax({
            url: '/api/isauthenticated',
            dataType: "json"
        })
            .done(function (response) {
                if (response === false) {
                    //refresh the page so map enforces rule for anonymous
                    location.reload();
                }
            })
            .fail(function (err) {
                //ignore
            });
    }
}
